import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { openModal, MODAL_TYPES } from '@alphapoint/apex-web/lib/redux/actions/modalActions';
import PageHeaderLayout from '../layouts/PageHeaderLayout/PageHeaderLayout';
import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';

import DashboardPage from './DashboardPage';
import MarketDataPage from './MarketDataPage';
import BuySellPage from './BuySellPage';
// import ConvertPage from '@alphapoint/apex-web/lib/layouts/ConvertLayout/ConvertLayout';
import ProductDetailsPage from './ProductDetailsPage';
import SettingsPage from './SettingsPage';
import { TradingPage as TradingPageContainer } from './Exchange/TradingPage';

import WalletsLayout from '@alphapoint/apex-web/lib/layouts/WalletsLayout/WalletsLayoutContainer';
import AssetActivityDetailsLayout from '@alphapoint/apex-web/lib/layouts/AssetActivityDetailsLayout/AssetActivityDetailsLayout';

import DigitalAssetsPage from '@alphapoint/apex-web/lib/components/DigitalAssets/DigitalAssetsPageContainer';
import DigitalAssetsOfferingProfilePage from '@alphapoint/apex-web/lib/components/DigitalAssets/DigitalAssetsOfferingProfilePageContainer';
import forVerified from '../hocs/forVerified';
import IBALayout from '@alphapoint/apex-web/lib/components/IBA/IbaLayout';

import StreamingPage from './StreamingPage';
import { marginBorrowerEnabledSelector } from '@alphapoint/apex-web/lib/redux/margin/selectors/marginSelectors';
import { futuresEnabledSelector } from '@alphapoint/apex-web/lib/redux/futures/selectors/futuresSelectors';
import ExchangeNavModalContainer from '@alphapoint/apex-web/lib/components/ExchangeNavModal/ExchangeNavModalContainer';

const WalletsComponent = () => <WalletsLayout detailsLink="/activity" />;

const ExchangeRouteGuard = ({ accountType, redirectTo }) => {
  const dispatch = useDispatch();
  const marginEnabled = useSelector(marginBorrowerEnabledSelector);
  const futuresEnabled = useSelector(futuresEnabledSelector);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  if (accountType === 'Margin' && !marginEnabled) {
    dispatch(openModal(MODAL_TYPES.EXCHANGE_NAV_WARNING, { feature: 'Margin' }));
    return <Redirect to="/dashboard" />;
  }

  if (accountType === 'Futures' && !futuresEnabled) {
    dispatch(openModal(MODAL_TYPES.EXCHANGE_NAV_WARNING, { feature: 'Futures' }));
    return <Redirect to="/dashboard" />;
  }

  return <TradingPageContainer />;
};

const exchangeRoutes = [
  { path: '/exchange', exact: true, redirectTo: '/exchange/spot' },
  { path: '/exchange/spot/:symbol?', accountType: 'Asset' },
  { path: '/exchange/margin/:symbol?', accountType: 'Margin' },
  { path: '/exchange/futures/:symbol?', accountType: 'Futures' },
  { path: '/exchange/:symbol?', accountType: 'Asset' },
];

const routesConfig = [
  { path: '/dashboard', component: DashboardPage, exact: true },
  { path: '/dashboard/market-data', component: MarketDataPage },
  { path: '/wallets', component: WalletsComponent },
  { path: '/buy-sell', component: BuySellPage },
  // { path: '/convert', component: ConvertPage },
  { path: '/iba', component: IBALayout },
  { path: '/activity', component: ProductDetailsPage },
  { path: '/settings', component: SettingsPage },
  { path: '/asset-activity-details', component: AssetActivityDetailsLayout },
  { path: '/eotc', component: StreamingPage },
  { path: '/token-offerings', component: DigitalAssetsPage, exact: true },
  { path: '/token-offerings/:id', component: DigitalAssetsOfferingProfilePage },
];

const InteriorPage = () => {
  return (
    <React.Fragment>
      <PageHeaderLayout />
      <ExchangeNavModalContainer />
      <Switch>
        {exchangeRoutes.map(({ path, exact, accountType, redirectTo }) => (
          <Route
            key={`${path}-${accountType || 'redirect'}`}
            exact={exact}
            path={path}
            render={(routeProps) => (
              <ExchangeRouteGuard accountType={accountType} redirectTo={redirectTo} {...routeProps} />
            )}
          />
        ))}
        {routesConfig.map((route, index) => {
          return <Route key={index} exact={route.exact} path={route.path} component={route.component} />;
        })}
      </Switch>
    </React.Fragment>
  );
};

export default withAuthentication(forVerified(InteriorPage));
